import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError, IPaginationResponse } from 'api/types';

export interface ISeoTranslation {
  language: string;
  translation: string;
}

export interface ISeoPageInfoItem {
  id: number;
  url_shortcut: string;
  url_shortcut_array: ISeoTranslation[];
  page_type: string;
  params: string;
  entity_id: number;
  entity_type: string;
  full_url: string;
  h1: ISeoTranslation[];
  meta_title: ISeoTranslation[];
  meta_description: ISeoTranslation[];
  meta_keywords: ISeoTranslation[];
  open_graph_title: ISeoTranslation[];
  open_graph_description: ISeoTranslation[];
  open_graph_image: ISeoTranslation[];
}

interface IRequest {
  limit?: number;
  pageType?: string;
  entityType?: string;
  entityId?: number;
}

type IResponse = IPaginationResponse<ISeoPageInfoItem>;

const getSeoPageInfo = (params: IRequest): Promise<IResponse> =>
  axios.get('/panel/seo-page-info', { params });

export const useGetSeoPageInfo = (
  params: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['seo-page-info', params],
    () => getSeoPageInfo(params),
    options
  );
